/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 16:12:57
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-18 17:08:29
 * @name: 主页对象
 * @Description: 主页对象
 * @FilePath: \project\src\views\index\index.view.js
 * @Author: desktop
 */
// import userService from "@/service/user.service";
import userService from "@/module/user/user.service";
import departmentService from "@/module/department/department.service";
import { indexRouterLinkConfig } from "@/config/indexRouterLink.config";
import { debounceation } from "@/utils/decorator";
const indexView = class {
  constructor(ctx) {
    this.ctx = ctx;
    this.userService = new userService();
    this.departmentService = new departmentService();
    this.bread = []; //顶部面包屑
    this.indexRouterLinkConfig = indexRouterLinkConfig;
    this.indexRouterLinkActive = '';
    this.userInfo = {}; //用户信息
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取用户信息
   */
  getUserInfo() {
    this.departmentService.getUserInfo().then(res => {
      this.ctx.$store.dispatch('user/changeUserInfo',res?.data ?? {});
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 退出登录
   */
  @debounceation(300)
  logout() {
    return this.userService.logout();
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 激活项变更
   */
  @debounceation(300, true, false)
  activedChange(url) {
    if (url === '/index') {
      url = '/' + this.ctx.$router.options.routes.find(x => x.path === url).redirect;
    }
    if (this.indexRouterLinkActive !== url) {
      this.ctx.$router.push(url);
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 设置头部标题
   * @param {Object} route 路由
   */
  setTitle(route) {
    this.bread = route.matched;
  }
}

export default indexView;